var map = {
	"./svg/HTML5.svg": 934,
	"./svg/actix.svg": 935,
	"./svg/aiohttp.svg": 936,
	"./svg/android.svg": 937,
	"./svg/angularjs.svg": 938,
	"./svg/app-engine.svg": 939,
	"./svg/apple.svg": 940,
	"./svg/aws.svg": 941,
	"./svg/awslamda.svg": 942,
	"./svg/azure.svg": 943,
	"./svg/backbone.svg": 944,
	"./svg/blazor.svg": 945,
	"./svg/bootstrap.svg": 946,
	"./svg/bottle.svg": 947,
	"./svg/capacitor.svg": 948,
	"./svg/celery.svg": 949,
	"./svg/chalice.svg": 950,
	"./svg/clojure.svg": 951,
	"./svg/connect.svg": 952,
	"./svg/cordova.svg": 953,
	"./svg/cryengine.svg": 954,
	"./svg/csharp.svg": 955,
	"./svg/dart.svg": 956,
	"./svg/default.svg": 957,
	"./svg/django.svg": 958,
	"./svg/dotnet.svg": 959,
	"./svg/dotnetcore.svg": 960,
	"./svg/dotnetfx.svg": 961,
	"./svg/electron.svg": 962,
	"./svg/elixir.svg": 963,
	"./svg/ember.svg": 964,
	"./svg/express.svg": 965,
	"./svg/falcon.svg": 966,
	"./svg/flask.svg": 967,
	"./svg/flutter.svg": 968,
	"./svg/fsharp.svg": 969,
	"./svg/gatsby.svg": 970,
	"./svg/gcp.svg": 971,
	"./svg/go.svg": 972,
	"./svg/godot.svg": 973,
	"./svg/google.svg": 974,
	"./svg/java.svg": 975,
	"./svg/javascript.svg": 976,
	"./svg/koa.svg": 977,
	"./svg/kotlin.svg": 978,
	"./svg/laravel.svg": 979,
	"./svg/logback.svg": 980,
	"./svg/nativec.svg": 981,
	"./svg/nextjs.svg": 982,
	"./svg/nodejs.svg": 983,
	"./svg/perl.svg": 984,
	"./svg/php.svg": 985,
	"./svg/pyramid.svg": 986,
	"./svg/python.svg": 987,
	"./svg/qt.svg": 988,
	"./svg/rails.svg": 989,
	"./svg/react.svg": 990,
	"./svg/redis.svg": 991,
	"./svg/redux.svg": 992,
	"./svg/ruby.svg": 993,
	"./svg/rust.svg": 994,
	"./svg/scala.svg": 995,
	"./svg/sentry.svg": 996,
	"./svg/serverless.svg": 997,
	"./svg/sinatra.svg": 998,
	"./svg/spring.svg": 999,
	"./svg/springboot.svg": 1000,
	"./svg/stride3d.svg": 1001,
	"./svg/swift.svg": 1002,
	"./svg/symfony.svg": 1003,
	"./svg/tornado.svg": 1004,
	"./svg/tryton.svg": 1005,
	"./svg/unity.svg": 1006,
	"./svg/uno.svg": 1007,
	"./svg/unreal.svg": 1008,
	"./svg/vue.svg": 1009,
	"./svg/xamarin.svg": 1010,
	"./svg_80x80/HTML5.svg": 1676,
	"./svg_80x80/actix.svg": 1677,
	"./svg_80x80/aiohttp.svg": 1678,
	"./svg_80x80/android.svg": 1679,
	"./svg_80x80/angularjs.svg": 1680,
	"./svg_80x80/app-engine.svg": 1681,
	"./svg_80x80/apple.svg": 1682,
	"./svg_80x80/aws.svg": 1683,
	"./svg_80x80/awslamda.svg": 1684,
	"./svg_80x80/azure.svg": 1685,
	"./svg_80x80/backbone.svg": 1686,
	"./svg_80x80/blazor.svg": 1687,
	"./svg_80x80/bootstrap.svg": 1688,
	"./svg_80x80/bottle.svg": 1689,
	"./svg_80x80/capacitor.svg": 1690,
	"./svg_80x80/celery.svg": 1691,
	"./svg_80x80/chalice.svg": 1692,
	"./svg_80x80/clojure.svg": 1693,
	"./svg_80x80/connect.svg": 1694,
	"./svg_80x80/cordova.svg": 1695,
	"./svg_80x80/cryengine.svg": 1696,
	"./svg_80x80/csharp.svg": 1697,
	"./svg_80x80/dart.svg": 1698,
	"./svg_80x80/default.svg": 1699,
	"./svg_80x80/django.svg": 1700,
	"./svg_80x80/dotnet.svg": 1701,
	"./svg_80x80/dotnetcore.svg": 1702,
	"./svg_80x80/dotnetfx.svg": 1703,
	"./svg_80x80/electron.svg": 1704,
	"./svg_80x80/elixir.svg": 1705,
	"./svg_80x80/ember.svg": 1706,
	"./svg_80x80/express.svg": 1707,
	"./svg_80x80/falcon.svg": 1708,
	"./svg_80x80/flask.svg": 1709,
	"./svg_80x80/flutter.svg": 1710,
	"./svg_80x80/fsharp.svg": 1711,
	"./svg_80x80/gatsby.svg": 1712,
	"./svg_80x80/gcp.svg": 1713,
	"./svg_80x80/go.svg": 1714,
	"./svg_80x80/godot.svg": 1715,
	"./svg_80x80/google.svg": 1716,
	"./svg_80x80/java.svg": 1717,
	"./svg_80x80/javascript.svg": 1718,
	"./svg_80x80/koa.svg": 1719,
	"./svg_80x80/kotlin.svg": 1720,
	"./svg_80x80/laravel.svg": 1721,
	"./svg_80x80/logback.svg": 1722,
	"./svg_80x80/nativec.svg": 1723,
	"./svg_80x80/nextjs.svg": 1724,
	"./svg_80x80/nodejs.svg": 1725,
	"./svg_80x80/perl.svg": 1726,
	"./svg_80x80/php.svg": 1727,
	"./svg_80x80/pyramid.svg": 1728,
	"./svg_80x80/python.svg": 1729,
	"./svg_80x80/qt.svg": 1730,
	"./svg_80x80/rails.svg": 1731,
	"./svg_80x80/react.svg": 1732,
	"./svg_80x80/redis.svg": 1733,
	"./svg_80x80/redux.svg": 1734,
	"./svg_80x80/ruby.svg": 1735,
	"./svg_80x80/rust.svg": 1736,
	"./svg_80x80/scala.svg": 1737,
	"./svg_80x80/sentry.svg": 1738,
	"./svg_80x80/serverless.svg": 1739,
	"./svg_80x80/sinatra.svg": 1740,
	"./svg_80x80/spring.svg": 1741,
	"./svg_80x80/springboot.svg": 1742,
	"./svg_80x80/stride3d.svg": 1743,
	"./svg_80x80/swift.svg": 1744,
	"./svg_80x80/symfony.svg": 1745,
	"./svg_80x80/tornado.svg": 1746,
	"./svg_80x80/tryton.svg": 1747,
	"./svg_80x80/unity.svg": 1748,
	"./svg_80x80/uno.svg": 1749,
	"./svg_80x80/unreal.svg": 1750,
	"./svg_80x80/vue.svg": 1751,
	"./svg_80x80/xamarin.svg": 1752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 933;